<div [ngStyle]="{'margin-top': '10px'}" ngStyle.lt-md="{'margin-top': '10px'}">

  <div class="retrofit-task-item-title">
    <span>Permit Information</span>
  </div>
  <mat-divider [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>

  <p style="font-size: 13px; font-weight: 500; margin-top: 3px; margin-bottom: 15px;">
    Your Permit Date must be after your EBB Program accepted date. Please <a routerLink="/contact">contact us</a> if you have any questions.
  </p>
  <form [formGroup]="formPermitInfo"
    [ngStyle]="{'width': '70%'}" ngStyle.lt-lg="{'width': '100%'}">
   
    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px" fxLayoutGap.lt-md="3px">
      <div fxFlex="50%">
        <mat-form-field
          appearance="outline"
          style="min-width: 250px;">
          <mat-label>Permit Issuer</mat-label>
          <input matInput autocomplete="off"
            placeholder="City or County issuing permit"
            maxLength="50"
            id="permitIssuer"
            name="permitIssuer"
            formControlName="permitIssuer">
            <mat-error
              *ngIf="onCheckPermitControlValidators('permitIssuer')">
              Permit issuer required
            </mat-error>
            <mat-hint *ngIf="formPermitInfo.get('permitIssuer').value && formPermitInfo.get('permitIssuer').value.length >= 50">
              Maximum 50 characters
            </mat-hint>
        </mat-form-field>
      </div><div fxFlex="50%">
        <mat-form-field appearance="outline" id="permitIssuedDateField" style="min-width: 250px;">
          <mat-label>Permit Issued Date </mat-label>
          <input matInput autocomplete="off"
            [min]="!isEMR() ? (application.acceptedDate | date:'yyyy-MM-dd') : null"
            [matDatepicker]="permitIssueDatePicker"
            placeholder="Date permit was issued"
            id="permitIssuedDate"
            name="permitIssuedDate"
            formControlName="permitIssuedDate">
          <mat-datepicker-toggle matSuffix [for]="permitIssueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #permitIssueDatePicker
            [startAt]="!isEMR() ? (application.acceptedDate | date:'yyyy-MM-dd') : null">
          </mat-datepicker>
        
          <!-- Show error only if the program is NOT EMR -->
          <mat-error *ngIf="!isEMR() && onCheckPermitControlValidators('permitIssuedDate')">
            Permit issued date required on/after {{application.acceptedDate | date:'MM/dd/yyyy'}}
          </mat-error>
          <mat-error *ngIf="isEMR() && onCheckPermitControlValidators('permitIssuedDate')">
            Permit issued date required.
          </mat-error>
          
          <!-- Show hint only if the program is NOT EMR -->
          <mat-hint *ngIf="!isEMR() && formPermitInfo.get('permitIssuedDate').value
            && (formPermitInfo.get('permitIssuedDate').value < application.acceptedDate)">
            Date must be after EBB accepted date.
          </mat-hint>
        </mat-form-field>        
      </div>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px" fxLayoutGap.lt-md="3px">
      <div fxFlex="50%">
        <mat-form-field
        appearance="outline"
        style="min-width: 250px;">
        <mat-label>Permit Plan Type</mat-label>
        <select matNativeControl
          id="permitPlanType"
          name="permitPlanType"
          formControlName="permitPlanType">
            <option value="">-- Select One --</option>
            <option *ngFor="let item of filteredPermitPlanTypeOptions"
              [value]="item.value">{{item.label}}</option>
        </select>
        <mat-error
          *ngIf="onCheckPermitControlValidators('permitPlanType')">
          Permit plan type required
        </mat-error>
        </mat-form-field>
      </div><div fxFlex="50%">
        <mat-form-field
          appearance="outline"
          style="min-width: 250px;">
          <mat-label>Permit Number</mat-label>
          <input matInput autocomplete="off"
            maxlength="20"
            placeholder="Permit number"
            id="permitNumber"
            name="permitNumber"
            formControlName="permitNumber"
             >
            <mat-error
              *ngIf="onCheckPermitControlValidators('permitNumber')">
              Permit number required
            </mat-error>
            <mat-hint *ngIf="formPermitInfo.get('permitNumber').value && formPermitInfo.get('permitNumber').value.length >= 20">
              Maximum 20 characters
            </mat-hint>
        </mat-form-field>
      </div>
    </div>



    <button
      *ngIf="!checkPermitFormLock()"
      mat-raised-button color="primary"
      type="submit"
      (click)="onClickSavePermitInfo()"
      [disabled]="formPermitInfo.pristine || formPermitInfo.invalid">
      {{saveButtonLabel}}
    </button>

    <!-- <div *ngIf="homeownerPaidForPermit && application.programType !== 700000003">
      <br/>
      If a Supplemental Grant participant paid for the building permit, they can request immediate reimbursement for the cost of the permit by uploading the receipt.
    </div> -->

    <div *ngIf="formAutoSavePermit" style="margin-top: 12px;">
      <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
    </div>
  </form>
</div>
